export const RSVP_PROCESS_COMPANIONS = 'companionInvitation';
export const RSVP_PROCESS_COMPLETE = 'welcome';
export const RSVP_PROCESS_DOCUMENTS = 'legalForms';
export const RSVP_PROCESS_INTRODUCTION = 'introduction';
export const RSVP_PROCESS_PERMISSION = 'permission';
export const RSVP_PROCESS_PERSONAL = 'guestProfile';

export const STEP_BY_RSVP_PROCESS = {
    [RSVP_PROCESS_COMPANIONS]: 'companions',
    [RSVP_PROCESS_COMPLETE]: 'complete',
    [RSVP_PROCESS_DOCUMENTS]: 'documents',
    [RSVP_PROCESS_INTRODUCTION]: 'introduction',
    [RSVP_PROCESS_PERMISSION]: 'permission',
    [RSVP_PROCESS_PERSONAL]: 'personal-information',
};

export const STATUS_ACCEPTED = 'y';
export const STATUS_DECLINE = 'n';
export const STATUS_PENDING = 'p';
export const STATUS_WAITLIST = 'w';
